import React, {useState, useRef} from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import analyticsClient, {AnalyticsEvent} from 'src/services/analytics';
import type {ELeadStage} from 'src/services/api';
import {StageChip} from 'src/components/input/select-lead-stage/SelectLeadStage';
import {leadStageOptions} from 'src/components/input/select-lead-stage/leadStageOptions';

interface Props {
    value: ELeadStage,
    onChange: (value: ELeadStage) => void
    isWarning?: boolean
}

export const SelectLeadStage = ({
    value,
    onChange,
    isWarning = false
}: Props) => {
    const ref = useRef<HTMLDivElement>(null);

    const [isOpened, setOpened] = useState(false);

    const handleMenuItemClick = (newValue: ELeadStage) => {
        setOpened(false);
        onChange(newValue);
    };

    const handleOpen = () => {
        setOpened(true);
        analyticsClient.track(
            AnalyticsEvent.USED_SMART_NOTIFICATION_CHANGE_STAGE,
        );
    };

    return (
        <>
            {/*es thinks that ref does not exist on button but it does*/}
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/*@ts-expect-error*/}
            <Button variant="outlined" color={isWarning ? 'error' : 'primary'} onClick={handleOpen} ref={ref}>
                <Typography fontSize={14} fontWeight={600} component="div" color="inherit">
                    Change Stage
                </Typography>
            </Button>

            {isOpened && (
                <Menu
                    anchorEl={ref.current}
                    open={true}
                    onClose={() => setOpened(false)}
                    disableScrollLock
                >
                    {leadStageOptions.map((option) => (
                        <MenuItem
                            key={option.value}
                            onClick={() => handleMenuItemClick(option.value)}
                            sx={{ bgcolor: option.value === value ? 'grey.200' : 'transparent' }}
                        >
                            <StageChip value={option.value} />
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </>
    );
};
